<template>
  <div class="is-marginless is-paddingless" v-if="clientInformation">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('detailClient.title', { nomCommercial: getNameCompteComptableOrNot })}}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"></app-breadcrumb>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons ">
            <dropdownButton
              v-if="tiersId"
              :permission="permsClientsContact.maj"
              :actions="actionSecondary"
              @click="$router.push({
                name: 'm.bodac.clients/contacts-editClient',
                params: { id: tiersId },
              })"
              type="is-addOrEdit"
              class="mgr-2">
              {{ $t('detailClient.actions.edit') }}&nbsp;
            </dropdownButton>
              <b-dropdown class="button is-bottom-left">
                <div slot="trigger" class="right">
                  <b-icon icon="call-split" type="is-default" class="mgt-5px"></b-icon>
                  <b-icon icon="chevron-down" class="has-text-default"></b-icon>
                </div>
                <b-dropdown-item class="pdl-20px">
                <p class="has-text-icon-more is-size-7 has-text-left">
                  {{$t('detailClient.lienVersClient.title')}}
                </p>
                </b-dropdown-item>
                <b-dropdown-item class="is-paddingless has-text-left"
                                 v-for="(accesRapide, index) in genererAllAccesRapide" :key="index">
                  <router-link-blank :to="{ name: accesRapide.name,
                                      params: accesRapide.params}"
                                     class="pdt-5px pdb-5px"
                                     classMessage="has-text-default is-size-6 is-block
                                     mgl-20px mgr-20px"
                                     classComposant="noTextDecoration"
                                     :message="accesRapide.libelle">
                  </router-link-blank>
                </b-dropdown-item>
              </b-dropdown>
            <button class="button is-bottom-left has-text-left"
                    @click="checkPermissions(permsClientsContact.lecture)
                      ? popUpEdition = true
                      : showPopUp()">
              <b-icon icon="file-download" type="is-default"></b-icon>
            </button>
            <piece-jointe-button
              class="mgr-2"
              :perm="permsClientsContact.maj"
              autoSave>
            </piece-jointe-button>
          </div>
        </div>
      </div>
      <qd-message type="is-warning" has-icon v-if="isLocked" :closable="false"
        icon-size="is-medium">
        <div class="columns is-vcentered">
          <div class="column is-10">
            <p class="has-text-weight-bold">
              {{ $t('detailClient.informations.lockTitle') }}
            </p>
            <p>{{ libelleBlocage() }}</p>
            <p>{{ clientInformation.descriptionBlocage }}</p>
          </div>
        </div>
      </qd-message>
      <div class="tab">
        <ul>
          <router-link :to="{ name: 'c.bodac.clients/contacts-client' }"
                       :class="{'text-access-no-permission':
                                   !checkPermissions(permsClientsContact.lecture)}">
            <li :class="{
            'is-active': $router.currentRoute.name === 'c.bodac.clients/contacts-client'
            }">
              {{ $t('detailClient.informationsHeader') }}
            </li>
          </router-link>
          <router-link :to=" {name: 'c.bodac.clients/contacts-enCours' }"
                       :class="{'text-access-no-permission':
                                   !checkPermissions(permsClientsContact.lecture)}">
            <li :class="{
            'is-active': $router.currentRoute.name === 'c.bodac.clients/contacts-enCours'
            }">
              {{ $t('enCoursTiers.enCoursClient') }}
            </li>
          </router-link>
          <router-link :to=" {name: 'c.bodac.clients/contacts-compte' }"
                       :class="{'text-access-no-permission':
                                   !checkPermissions(permsClientsContact.lecture)}">
            <li :class="{
            'is-active': $router.currentRoute.name === 'c.bodac.clients/contacts-compte'
            }">
              {{ $t('detailClient.compteHeader') }}
            </li>
          </router-link>
          <router-link :to=" {name: 'c.bodac.clients/contacts-devis' }"
            :class="{'text-access-no-permission': !checkPermissions(permsClientsContact.lecture)}">
            <li :class="{'is-active'
              : $router.currentRoute.name === 'c.bodac.clients/contacts-devis'}">
                {{ $t('detailClient.generalTitle.devis') }}
            </li>
          </router-link>
          <router-link :to=" {name: 'c.bodac.clients/contacts-listeVentes' }"
                       :class="{'text-access-no-permission':
                                   !checkPermissions(permsClientsContact.lecture)}">
            <li :class="{
            'is-active': $router.currentRoute.name === 'c.bodac.clients/contacts-listeVentes'
            }">
              {{ $t('listeVentesForClient.title') }}
            </li>
          </router-link>
          <router-link :to=" {name: 'c.bodac.clients/contacts-factures' }"
            :class="{'text-access-no-permission': !checkPermissions(permsClientsContact.lecture)}">
            <li :class="{'is-active'
              : $router.currentRoute.name === 'c.bodac.clients/contacts-factures'}">
                {{ $t('detailClient.generalTitle.facture') }}
            </li>
          </router-link>
          <router-link :to=" {name: 'c.bodac.clients/contacts-organisation' }"
                       :class="{'text-access-no-permission':
                                   !checkPermissions(permsClientsContact.lecture)}"
          v-if="clientInformation.typologie !== typoAucun
          && clientInformation.typologie !== typoPointVente">
            <li :class="{
            'is-active': $router.currentRoute.name === 'c.bodac.clients/contacts-organisation'
            }">
              {{ $t('detailClient.generalTitle.organisation') }}
            </li>
          </router-link>
          <router-link :to=" {name: 'c.bodac.clients/contacts-portail' }"
                       v-if="clientInformation.urlPortailAnnonceur"
                       :class="{'text-access-no-permission':
                                   !checkPermissions(permsClientsContact.lecture)}">
            <li :class="{
            'is-active': $router.currentRoute.name === 'c.bodac.clients/contacts-portail'
            }">
              {{ $t('detailClient.generalTitle.portail') }}
            </li>
          </router-link>
          <router-link :to=" {name: 'c.bodac.clients/contacts-budget' }"
                        v-if="isAfficheBudget"
                       :class="{'text-access-no-permission':
                                   !checkPermissions(permsClientsContact.lecture)}">
            <li :class="{
            'is-active': $router.currentRoute.name === 'c.bodac.clients/contacts-budget'
            }">
              {{ $t('detailClient.generalTitle.budget') }}
            </li>
          </router-link>
          <router-link :to=" { name: 'c.bodac.clients/contacts-retardPaiement' }"
             :class="{'text-access-no-permission': !checkPermissions(permsClientsContact.lecture)}">
            <li :class="{'is-active'
              : $router.currentRoute.name === 'c.bodac.clients/contacts-retardPaiement'}">
              {{ $t('detailClient.generalTitle.retardPaiement') }}
            </li>
          </router-link>
          <router-link :to=" {name: 'c.bodac.clients/contacts-relances' }"
                       :class="{'text-access-no-permission':
                                   !checkPermissions(permsClientsContact.lecture)}">
            <li :class="{
            'is-active': $router.currentRoute.name === 'c.bodac.clients/contacts-relances'
            }">
              {{ $t('listeRelanceForClient.title') }}
            </li>
          </router-link>
          <router-link :to=" {name: 'c.bodac.clients/contacts-dispositif' }"
            :class="{'text-access-no-permission': !checkPermissions(permsClientsContact.lecture)}"
            v-if="moduleEmplacementClientActive">
            <li :class="{'is-active'
              : $router.currentRoute.name === 'c.bodac.clients/contacts-dispositif'}">
              {{ $t('detailClient.generalTitle.dispositifs') }}
            </li>
          </router-link>
          <router-link :to=" {name: 'c.bodac.clients/contacts-ligne-commandes' }"
            :class="{'text-access-no-permission': !checkPermissions(permsClientsContact.lecture)}"
            v-if="ligneCommandeARenouvelerSpe">
            <li :class="{'is-active'
              : $router.currentRoute.name === 'c.bodac.clients/contacts-ligne-commandes'}">
              {{ $t('detailClient.generalTitle.lignesCommandesARenouveler') }}
            </li>
          </router-link>
          <router-link :to=" {name: 'c.bodac.clients/contacts-stock' }"
            v-if="moduleStockTiersActive"
            :class="{'text-access-no-permission': !checkPermissions(permsClientsContact.lecture)}">
            <li :class="{'is-active'
              : $router.currentRoute.name === 'c.bodac.clients/contacts-stock'}">
              {{ $t('detailClient.generalTitle.mouvementStock') }}
            </li>
          </router-link>
          <router-link :to=" {name: 'c.bodac.clients/contacts-demandeImpression' }"
            v-if="moduleDemandeImpressionActive"
            :class="{'text-access-no-permission': !checkPermissions(permsClientsContact.lecture)}">
            <li :class="{'is-active'
              : $router.currentRoute.name === 'c.bodac.clients/contacts-demandeImpression'}">
              {{ $t('detailClient.generalTitle.demandeImpression') }}
            </li>
          </router-link>
        </ul>
      </div>
    </div>
    <router-view :tiersId="this.tiersId"
                 :portail-client-base-url="clientInformation.urlPortailAnnonceur"
                 :soldeAtInfiniteDay="soldeAtInfiniteDay"
                 :tiersInformation="clientInformation"
                 :soldeTiersInfo="soldeClientInfo"
                 :isFromDetailClient="true"
                 :soldeClientInfo="soldeClientInfo"
                 :numberMouvement=total
                 :factureClientHupmediaActive="factureClientHupmediaActive"
                 v-if="clientInformation">
    </router-view>
    <b-modal v-model="openPopUpLevelBlocage" has-modal-card class="modal" v-if="clientInformation">
      <popup-level-blocage
        :tiers="clientInformation"
        :unlock="unlock"
        @refresh="closeAndSearch">
      </popup-level-blocage>
    </b-modal>
    <b-modal v-model="openPopUpGenerateMandat" has-modal-card class="modal"
      v-if="clientInformation">
      <popup-generate-mandat
        :tiers="clientInformation"
        @refresh="closeAndSearch">
      </popup-generate-mandat>
    </b-modal>
    <b-modal
      v-if="clientInformation"
      v-model="openPopUpFusionTiers"
      :width="800"
      class="modal"
      has-modal-card>
      <popup-fusion-tiers
        :tiers="clientInformation"
        :type="constantes.TIERS_TYPE_CLIENT"
        :sousTypes="[constantes.TIERS_SOUS_TYPE_AUCUN]">
      </popup-fusion-tiers>
    </b-modal>
    <b-modal
      v-if="clientInformation"
      v-model="openPopUpDeleteTiers"
      width="400px"
      class="modal"
      has-modal-card>
      <popup-delete-tiers
        @refresh="$router.push({ name: 'l.bodac.clients/contacts-clients' })"
        :tiers="clientInformation"/>
    </b-modal>
    <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :error="errorEdition"
        :choiceEdition="listeChoiceEdition"
        :filtreDates="true"
        @editionChoose="edition">
      </pop-up-edition>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import dropdownButton from '@/components/general/button/dropdownButton';
import breadcrumb from '@/components/general/breadcrumb';
import messageErreur from '@/services/general/messageErreur';
import { get } from '@/api/tiers/index';
import { getSolde } from '@/api/mouvementClient/index';
import formatIsoDate from '@/services/general/formatIsoDate';
import { TIERS } from '@/configuration/permissionsBodacConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { SENS_VENTE } from '@/configuration/devisConf';
import {
  TYPOLOGIE_POINT_DE_VENTE,
  TYPOLOGIE_AUCUN,
  TIERS_TYPE_CLIENT,
  TIERS_SOUS_TYPE_AUCUN, LISTE_CHOICE_EDITION_TIERS, TYPE_DONNEE_EXTRAIT_COMPTE_TIERS,
} from '@/configuration/tiers/tiersConf';
import { INFINITE_DAY } from '@/configuration/general';
import popupLevelBlocage from '@/components/clients/clients/popupLevelBlocage';
import { LIBRE } from '@/configuration/tiers/levelBlocage';
import formatDate from '@/services/general/formatDate';
import levelString from '@/services/tiers/levelToString';
import popupGenerateMandat from '@/components/clients/clients/popupGenerateMandat';
import popupFusionTiers from '@/components/clients/clients/popupFusionTiers';
import popupDeleteTiers from '@/components/clients/clients/popupDeleteTiers';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { OPERATION_DIVERSE } from '@/configuration/compta/permissionsComptaConf';
import genererOperationDiverse from '@/services/compta/operationDiverse/genererOperationDiverse';
import { SET_OPERATION_DIVERSE } from '@/store/modules/compta/operationDiverse-mutation-type';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import MixinParametreInterne from '@/mixins/parametreInterne';
import popUpEdition from '@/components/factures/p_edition';
import edition from '@/api/edition';
import validationGeneral from '@/services/validation/validation';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';

const MouvementsClient = createNamespacedHelpers('mouvementClient');
const Attachments = createNamespacedHelpers('attachments');
const permissions = createNamespacedHelpers('permissions');
const societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const operationDiverse = createNamespacedHelpers('operationDiverse');

export default {
  name: 'clientInterface',
  data() {
    return {
      tiersId: null,
      soldeClientInfo: 0,
      clientInformation: null,
      permsClientsContact: TIERS,
      permOperationDiverse: OPERATION_DIVERSE,
      typoAucun: TYPOLOGIE_AUCUN,
      typoPointVente: TYPOLOGIE_POINT_DE_VENTE,
      soldeAtInfiniteDay: 0,
      openPopUpLevelBlocage: false,
      openPopUpGenerateMandat: false,
      openPopUpFusionTiers: false,
      openPopUpDeleteTiers: false,
      unlock: false,
      constantes: {
        TIERS_TYPE_CLIENT,
        TIERS_SOUS_TYPE_AUCUN,
      },
      popUpEdition: false,
      listeChoiceEdition: LISTE_CHOICE_EDITION_TIERS
        .filter(l => l.typeDonnee === TYPE_DONNEE_EXTRAIT_COMPTE_TIERS),
      errorEdition: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
    };
  },
  mixins: [MixinParametreInterne],
  components: {
    popUpEdition,
    appBreadcrumb: breadcrumb,
    routerLinkBlank,
    popupLevelBlocage,
    popupGenerateMandat,
    dropdownButton,
    pieceJointeButton,
    popupFusionTiers,
    popupDeleteTiers,
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentElementId: 'setElementId',
    }),
    ...MouvementsClient.mapActions({
      actionsLoadMouvement: 'loadMouvementsClient',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...operationDiverse.mapMutations({
      setOperationDiverse: SET_OPERATION_DIVERSE,
    }),
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    async edition(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      this.errorEdition.champsVide = [];
      this.errorEdition.messagesChampsVide = [];
      this.errorEdition.messages = [];
      this.errorEdition.haveError = false;
      try {
        const response = await edition({
          ids: [this.clientInformation.id],
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: donnees.parametresAdditionnels,
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
        this.popUpEdition = false;
      } catch (e) {
        const errorResponseString = await readErrorBlobRequest(e.response.data);
        const response = JSON.parse(errorResponseString);
        validationGeneral(this.$i18n, { data: response }, this.errorEdition.champsVide,
          this.errorEdition.messages, this.errorEdition.messagesChampsVide);
        this.errorEdition.haveError = true;
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async getSoldeClient() {
      const param = {
        tiersId: this.tiersId,
        date: formatIsoDate(new Date()),
      };
      const responseSoldeClient = await getSolde(param);
      this.soldeClientInfo = responseSoldeClient.data.result;
    },
    async getSoldeAtInfiniteDay() {
      const param = {
        tiersId: this.tiersId,
        date: formatIsoDate(INFINITE_DAY),
      };
      const responseSoldeClient = await getSolde(param);
      this.soldeAtInfiniteDay = responseSoldeClient.data.result;
    },
    async loadMouvementClient() {
      const objectFilter = {
        query: {
          tiersId: this.tiersId,
          brouillard: false,
          societeId: this.societeActiveId,
        },
      };
      await this.actionsLoadMouvement(objectFilter);
    },
    async loadInformationclient() {
      const clientInformationResponse = await get(this.tiersId);
      clientInformationResponse.data.result.piecesJointes = [];
      this.clientInformation = clientInformationResponse.data.result;
      await this.setAttachmentElementId({ id: this.tiersId });
    },
    bloquer() {
      this.unlock = false;
      this.openPopUpLevelBlocage = true;
    },
    async closeAndSearch() {
      this.clientInformation = null;
      this.openPopUpLevelBlocage = false;
      this.openPopUpGenerateMandat = false;
      await this.loadInformationclient();
      await this.getSoldeClient();
      await this.getSoldeAtInfiniteDay();
      await this.loadMouvementClient();
    },
    levelDateStr() {
      if (this.clientInformation.dateBlocageLevel === undefined
        || this.clientInformation.dateBlocageLevel == null) {
        return '';
      }
      return formatDate(this.clientInformation.dateBlocageLevel);
    },
    libelleBlocage() {
      return this.$i18n.t('detailClient.informations.locked', {
        level: levelString(this.$i18n, this.clientInformation.blocageLevel),
        dateLevel: this.levelDateStr(),
      });
    },
    debloquer() {
      this.unlock = true;
      this.openPopUpLevelBlocage = true;
    },
    creerOd() {
      const od = genererOperationDiverse();
      od.mouvementOd.tiersId = this.tiersId;
      od.mouvementOd.tiers = this.clientInformation;
      this.setOperationDiverse(od);
      this.$router.push({ name: 'm.comptabilite.operation_diverse-add' });
    },
  },
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
    }),
    ...MouvementsClient.mapGetters({
      total: 'total',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    getNameCompteComptableOrNot() {
      if (this.clientInformation.compteComptable.length > 0) {
        const nameWithCompteComptable = this.clientInformation.nomCommercial
        + ' - ' + this.clientInformation.compteComptable;
        return nameWithCompteComptable;
      }
      return this.clientInformation.nomCommercial;
    },
    modulePlanMediaActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePlanMedia.key);
    },
    moduleStockTiersActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
    moduleDemandeImpressionActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.demandeImpression.key);
    },
    factureClientHupmediaActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.factureClientHupmedia.key);
    },
    genererAllAccesRapide() {
      const accesRapide = [
        { name: 'l.bodac.devis', params: { sens: SENS_VENTE, tiersId: this.tiersId }, libelle: this.$t('detailClient.lienVersClient.devis') },
        { name: 'l.bodac.commandes-liste', params: { sens: SENS_VENTE, tiersId: this.tiersId }, libelle: this.$t('detailClient.lienVersClient.commandes') },
        { name: 'l.bodac.factures', params: { sens: SENS_VENTE, tiersId: this.tiersId }, libelle: this.$t('detailClient.lienVersClient.avoirsFacturesAcomptes') },
        { name: 'l.bodac.relance-listeRelancesSave', params: { tiersId: this.tiersId }, libelle: this.$t('detailClient.lienVersClient.relances') },
      ];
      if (this.modulePlanMediaActive) {
        accesRapide.push({ name: 'l.presse.plan_media-par-tiers', params: { tiersId: this.tiersId }, libelle: this.$t('detailClient.lienVersClient.planMedia') });
      }
      if (this.moduleEmplacementClientActive) {
        accesRapide.push({ name: 'l.gabed.emplacement', params: { activeTab: 'emplacement', tiersId: this.tiersId }, libelle: this.$t('detailClient.lienVersClient.emplacements') });
        accesRapide.push({ name: 'l.gabed.emplacement', params: { activeTab: 'dispositif', tiersId: this.tiersId }, libelle: this.$t('detailClient.lienVersClient.dispositifs') });
        accesRapide.push({ name: 'l.gabed.emplacement', params: { activeTab: 'materiel', tiersId: this.tiersId }, libelle: this.$t('detailClient.lienVersClient.materiels') });
      }
      return accesRapide;
    },
    breadcrumb() {
      const output = [
        { title: this.$t('listeClients.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeClients.title'), route: { name: 'l.bodac.clients/contacts-clients' }, isActive: false },
        { title: this.$t('detailClient.title', { nomCommercial: this.clientInformation.nomCommercial }), route: { name: 'c.bodac.clients/contacts-client' }, isActive: true },
      ];
      return output;
    },
    isLocked() {
      if (this.clientInformation === undefined || this.clientInformation === null
        || this.clientInformation.blocageLevel === undefined) return false;
      return this.clientInformation.blocageLevel !== LIBRE;
    },
    isAfficheBudget() {
      return this.societeActive.roles.length > 1;
    },
    isPrelevementSepa() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.prelevementSepa.key);
    },
    actionSecondary() {
      const actions = [
        {
          label: this.$t('detailClient.actions.lock'),
          action: () => { this.bloquer(); },
          order: 1,
        },
        {
          label: this.$t('detailClient.actions.createOd'),
          action: () => { this.creerOd(); },
          order: 4,
        },
        {
          label: this.$t('detailClient.actions.fusionClient'),
          action: () => { this.openPopUpFusionTiers = true; },
          order: 5,
        },
        {
          label: this.$t('detailClient.actions.deleteClient'),
          action: () => { this.openPopUpDeleteTiers = true; },
          order: 6,
        },
      ];

      if (this.isLocked) {
        actions.push(
          {
            label: this.$t('detailClient.actions.unlock'),
            action: () => { this.debloquer(); },
            order: 2,
          },
        );
      }

      if (this.isPrelevementSepa) {
        actions.push(
          {
            label: this.$t('detailClient.actions.generateMandat'),
            action: () => { this.openPopUpGenerateMandat = true; },
            order: 3,
          },
        );
      }
      return actions;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.tiersId = this.$route.params.id;
      await this.loadInformationclient();
      await this.getSoldeClient();
      await this.getSoldeAtInfiniteDay();
      await this.loadMouvementClient();
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.prelevementSepa.key,
        PARAMETRES_INTERNE_KEYS.modulePlanMedia.key, PARAMETRES_INTERNE_KEYS.moduleStockTiers.key,
        PARAMETRES_INTERNE_KEYS.demandeImpression.key,
        PARAMETRES_INTERNE_KEYS.factureClientHupmedia.key]);
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
    this.setInformationPage(this.$t('pageGeneral.detail', { item: this.clientInformation.nomCommercial }));
  },
};
</script>

<style scoped>
</style>
